import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/images/arrow_left_black.svg'


const _hoisted_1 = { class: "v-card" }
const _hoisted_2 = { class: "v-card-header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "svg align-text-bottom text-black me-1",
  height: "18",
  width: "18",
  src: _imports_0
}, null, -1)
const _hoisted_4 = { class: "v-card-body" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { for: "Code" }
const _hoisted_7 = ["placeholder", "disabled"]
const _hoisted_8 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_9 = { for: "BrandName" }
const _hoisted_10 = ["placeholder", "disabled"]
const _hoisted_11 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_12 = { class: "col-md-12 form-group" }
const _hoisted_13 = { for: "Description" }
const _hoisted_14 = ["placeholder", "disabled"]
const _hoisted_15 = { class: "col-md-6 form-group" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = { class: "mx-3 my-4" }
const _hoisted_18 = { class: "mt-4" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_numeric_fld_input = _resolveComponent("numeric-fld-input")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, [
      _createVNode(_component_RouterLink, { to: "/app/products/brands/list" }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createTextVNode(" " + _toDisplayString(_ctx.language.new_brand), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: _normalizeClass(["col-md-6 form-group", {'has-error': _ctx.v$.dataRecord.Code.$error}])
        }, [
          _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.language.code), 1),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "Code",
            class: "form-control",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dataRecord.Code) = $event)),
            placeholder: '(' + _ctx.language.code.toLowerCase() + ')',
            maxlength: "15",
            autocomplete: "off",
            onFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectOnFocus($event))),
            disabled: _ctx.isSavingRecord
          }, null, 40, _hoisted_7), [
            [_vModelText, _ctx.dataRecord.Code]
          ]),
          (_ctx.v$.dataRecord.Code.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.v$.dataRecord.Code.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["col-md-6 form-group", {'has-error': _ctx.v$.dataRecord.BrandName.$error}])
        }, [
          _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.language.name), 1),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "BrandName",
            class: "form-control",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dataRecord.BrandName) = $event)),
            placeholder: '(' + _ctx.language.name.toLowerCase() + ')',
            maxlength: "50",
            autocomplete: "off",
            onFocus: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectOnFocus($event))),
            disabled: _ctx.isSavingRecord
          }, null, 40, _hoisted_10), [
            [_vModelText, _ctx.dataRecord.BrandName]
          ]),
          (_ctx.v$.dataRecord.BrandName.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.v$.dataRecord.BrandName.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.language.description), 1),
          _withDirectives(_createElementVNode("textarea", {
            id: "Description",
            class: "form-control",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dataRecord.Description) = $event)),
            placeholder: '(' + _ctx.language.description.toLowerCase() + ')',
            maxlength: "500",
            autocomplete: "off",
            onFocus: _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectOnFocus($event))),
            disabled: _ctx.isSavingRecord,
            rows: "4"
          }, null, 40, _hoisted_14), [
            [_vModelText, _ctx.dataRecord.Description]
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_numeric_fld_input, {
            modelValue: _ctx.TestNumeric,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.TestNumeric) = $event)),
            classes: 'form-control',
            placeholder: 'Hello boy',
            disabled: _ctx.isDisabled,
            id: 'TestNumeric'
          }, null, 8, ["modelValue", "disabled"]),
          _hoisted_16,
          _createTextVNode(" " + _toDisplayString(_ctx.TestNumeric), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary btn-block",
          disabled: _ctx.v$.$invalid || _ctx.isSavingRecord,
          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.saveNewBrand && _ctx.saveNewBrand(...args)))
        }, [
          (_ctx.isSavingRecord)
            ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                _createVNode(_component_font_awesome_icon, { icon: ['fa', 'fa-spinner'] }),
                _createTextVNode("  ")
              ]))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_ctx.language.save), 1)
        ], 8, _hoisted_19)
      ])
    ])
  ]))
}